import React, { Component } from 'react'
import './TipsOnDesigningMugs.css';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import Capture from '../../assets/images/tipsImage/Capture.JPG';
import mugTips from '../../assets/images/tipsImage/mugTips.JPG';
import mugTips1 from '../../assets/images/tipsImage/mugTips-1.JPG';
import mugTips2 from '../../assets/images/tipsImage/mugTips-2.JPG';
import mugTips3 from '../../assets/images/tipsImage/mugTips-3.JPG';
import mugTips4 from '../../assets/images/tipsImage/mugTips-4.JPG';


class TipsOnDesigningMugs extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />
                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Tips on Designing Mugs</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>

                    <div className="elementor-widget-container ctnr">
                        <h2 className="elementor-heading-title elementor-size-default mb-1">Mugs visuals and a few best</h2>
                        <h2 className="elementor-heading-title elementor-size-default"> combination color ink</h2>
                    </div>
                    
                    <div className="elementor-text-editor elementor-clearfix bdr">    

                        <p className="pg">
                            <span className="fnt-tips-color" style={{"fontWeight": "400"}}>
                                Mugs visuals and a few best combination color ink to choose to design your own mugs
                            </span>
                        </p>
                        
                        <div className="mt-2">
                            <h2 className="elementor-heading-title elementor-size-default mb-1 text-center mb-1">
                                WHY DESIGN CUSTOMIZED MUGS
                            </h2>
                        </div>   
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips">
                                    7. Why Give Coffee Mugs?
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={Capture} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                       <h4 className="step-size">
                                           Advertising
                                        </h4>
                                       <p className="step-size">
                                           Coffee mugs make a great canvas for your business logo or to prominently display a message associated with your business. Because they’re useful, they’re less likely to be discarded and may even see daily use. 
                                        </p>
                                       <p className="step-size">
                                           Each time someone takes a drink from a mug decorated with your business’s logo or tagline, you’ll be getting more exposure for your enterprise. 
                                        </p>
                                       <h4 className="step-size">
                                            Gift-Giving
                                        </h4>
                                       <p className="step-size">
                                           Specially designed mugs make the perfect heartfelt — and useful — gift for that special person in your life.
                                        </p>
                                        <p className="step-size">
                                            Adorned with inspirational sayings, custom artwork, and even personalised with the recipient’s name, a bespoke mug will convey the perfect sentiment for any occasion.
                                        </p>
                                        <h4 className="step-size">
                                            Home Décor
                                        </h4>
                                        <p className="step-size">
                                            A set of custom-printed mugs can be just the right addition to your kitchen or office. They can range from the simple, like monogrammed mugs or a set of inspirational sayings, to the sublime, like full-colour artwork or photographs.
                                        </p>
                                        <p className="step-size">
                                            No matter how you design them, custom mugs can inject your home with a touch of personality.
                                        </p>
                                        <h4 className="step-size">
                                            Home-Based Business
                                        </h4>
                                        <p className="step-size">
                                            Did you know that custom-printed mugs make an excellent idea for a work-from-home scheme?
                                        </p>
                                        <p className="step-size">
                                            Capitalising on the popularity of mugs is a great way to generate an income-producing business you can operate locally or online.
                                        </p>
                                        <p className="step-size">
                                            Simply create clever, one-of-a-kind designs or messages and have them carefully printed on high-quality mugs for an easy — and profitable — business idea.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>                                               
                        </div>    
                        <div className="mt-2">
                            <p className="pg">
                                <span className="fnt-tips-color title-steps font-weight-tips mb-1">
                                    8. TIPS TO MAKE YOUR OWN COFFEE MUG
                                </span>
                            </p>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size">
                                            1. Plan It Out
                                        </h1>
                                        <p className="step-size">
                                            Before undertaking any coffee mug design project, make sure you’ve planned out the design from start to finish. 
                                        </p>
                                        <p className="step-size">
                                            Things to consider include: 
                                        </p>
                                        <p className="step-size">
                                                • Does the design fit on the mug space?<br />
                                                • Will the design cover the entire mug or just one side?<br />
                                                • Will there be anything inside the mug?<br />
                                                • How many colours will the design use?<br />
                                                • Will the design be permanent, washable, or microwaveable?
                                        </p>
                                        <h1 className="step-size">
                                            2. Choose Your Base Mug for Durability
                                        </h1>
                                        <p className="step-size">
                                            You want to make sure your unique mug will be easy to take care of and stand up to years of use. That’s why you should look for mug blanks that are hand washable and dishwasher-safe for best results.
                                        </p>
                                        <h1 className="step-size">
                                            3. Use Color-Wisely
                                        </h1>
                                        <p className="step-size">
                                            Color can add real impact and value to your mug design, but sometimes too many colors can overpower an image and end up looking messy
                                        </p>
                                        <p className="step-size">
                                            Determine the right level of colour for your mug before undertaking the final product. A sketch is a great way to see if your design colors are just right — or is it too much.
                                        </p>
                                        <p className="step-size">
                                            If you’re having your mug professionally printed, using fewer colors can save you money.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips1} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size">
                                            4. Choose Your Color Mug
                                        </h1>
                                        <p className="step-size">
                                            Make every day’s tea and coffee a treat for yourself, add a little extra creativity. A larger-volume mug can make your and your’s love ones day a very special day! A big mug also fit more comfortably into the hands. 
                                        </p>
                                        <h1 className="step-size">
                                            5. Be Inspirational To Others
                                        </h1>
                                        <p className="step-size">
                                            People love to be inspired! Create <b>#Makeitwithstylecabbie</b> and Share your unique designing capabilities with us and others via <b>#Sharewithstylecabbie</b>. We would love to know about you and your creativity stories behind it. It’s time to show and tell your talent to others. 
                                        </p>
                                        <p className="step-size">
                                            You can choose a quote from a favourite public figure, author, or actor or even one of the memes circulating online to add a spark of inspiration to your custom mug.
                                        </p>
                                        <h1 className="step-size">
                                            6. Be Creative
                                        </h1>
                                        <p className="step-size">
                                            You’ll want to see your design in action before committing to printing or hand-making a mug. Sometimes, what seems good in your head doesn’t translate as well to a mug.
                                        </p>
                                        <p className="step-size">
                                            Take the time to sketch a drawing of your design on paper or cut a hand-drawn paper design out and test it on a mug to get a good idea for how the final product will look.
                                        </p>
                                    </div>                                   
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips2} alt="tipsImage"/>
                                        <img src={mugTips3} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size">
                                            7. Make It Memorable
                                        </h1>
                                        <p className="step-size">
                                            The more memorable your mug design, the more likely the recipient will give it pride of place in their home or office. Use designs that are unique or eye-catching to make your mug stand out from the rest. 
                                        </p>
                                        <h1 className="step-size">
                                            8. Share With Others
                                        </h1>
                                        <p className="step-size">
                                            Sharing your inner creativities outside your own drawing pages and let the world appreciate it. Take this leverage to create something that it very unique and different than what is available in the marketplace today and <b>#Sharewithstylecabbie</b>
                                        </p>
                                        <h1 className="step-size">
                                            9. Be Yourself
                                        </h1>
                                        <p className="step-size">
                                            One of the best ways to design your own coffee mug is to professionally print one at a custom printing shop online with StyleCabbie
                                        </p>
                                        <p className="step-size">
                                            StyleCabbie makes mug designing easy. You can upload your own design and add text through the online portal.
                                        </p>
                                        <p className="step-size">
                                            Having a professional printer transfer your custom artwork or photo onto a mug is one of the best ways to produce sharp, clear colours and lines coupled with unbeatable durability.
                                        </p>
                                        <p className="step-size">
                                            Mugs usually ship within 24 hours and are packed in durable boxes that are perfect for gift-wrapping and giving. 
                                        </p>
                                        <p className="step-size">
                                            <b>All you have to do is draw out your design, take an image, transfer it to the mugs online. Place it to the three sections {'>>'} Left Side, Center ,and Right side of the Mug. You can add three different designs or mix-match with image and texts.</b>
                                        </p>
                                    </div>                                   
                                </div>
                            </div>    
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src={mugTips4} alt="tipsImage"/>
                                    </div> 
                                    <div className="col-md-8">
                                        <h1 className="step-size mb-1">
                                            Why Make Your Own Coffee Mug Design?
                                        </h1>
                                        <p className="step-size">
                                            here are plenty of coffee mug designs out there, as a quick click around the internet or a browse in your local big-box store will attest. So, why should you bother designing your own? 
                                        </p>
                                        <p className="step-size">
                                            A custom-designed mug adds a touch of class, character, and charm that plain, store-bought mugs <b>just can’t match</b>. When you make your own coffee mug design, you create an end product that is uniquely yours.
                                        </p>
                                        <p className="step-size">
                                            These file types include Max file size: 5mb, accepted: jpg, gif ,and png. 
                                        </p>
                                        <p className="step-size">
                                            One of the best ways to design your own coffee mug is to professionally print one (or more) at a custom printing online shop  with StyleCabbie. 
                                        </p>
                                        <p className="step-size">
                                            Contact us today to learn more!
                                        </p>
                                        <p className="step-size">
                                            Remember to #tag your creativity designs  <b>#Makeitwithstylecabbie</b>  and <b>#Sharewithstylecabbie</b>.  
                                        </p>
                                        <div className="social-icons">
                                            <div className="links1">Follow us on</div>  
                                            <a href="https://www.facebook.com/stylecabbie" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                                            <a href="https://www.instagram.com/stylecabbie/" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-instagram"></i></a>
                                            {/* <a href="/" className="social-icon" target="_blank"><i className="icon-linkedin"></i></a> */}
                                        </div>
                                    </div>                                   
                                </div>
                            </div>                                                
                        </div>                           
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}
export default  TipsOnDesigningMugs 
